import React, { useState } from "react";
import "./OTPModal.css"; // Import CSS file
import { API_BASE_URL } from "./config";
import { useLoading } from "./LoadingContext";

const OTPModal = ({
  student_id,
  email,
  extraletters,
  onClose,
  showEditMail,
  editToken,
  onEmailChanged,
}) => {
  console.log(student_id, email);
  const [otp, setOtp] = useState("");
  const [userEmail, setUserEmail] = useState(email);
  const [isEditing, setIsEditing] = useState(false);
  const [newEmail, setNewEmail] = useState(email);
  const [isResending, setIsResending] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [Newextraletters, setNewextraletters] = useState(extraletters);
 const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const { showLoading, hideLoading } = useLoading();

  const handleOtpChange = (e) => {
    setOtp(e.target.value.replace(/\D/g, "").slice(0, 6)); // Allow only 6-digit numbers
  };

  const handleEditEmail = () => {
    setIsEditing(true);
  };

  const generateRandomCode = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    for (let i = 0; i < 4; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };

  const handleSubmitEmail = async () => {
    if (!newEmail.includes("@") || !newEmail.includes(".")) {
      setErrorMessage("❌ Please enter a valid email.");
      setTimeout(() => setErrorMessage(""), 5000); // Clear error after 5 sec
      return;
    }

    try {
      setIsSubmitting(true);
      showLoading(
        "🌐 AI is syncing your new email... OTP will arrive shortly."
      );
      if (!showEditMail || !editToken) {
        setErrorMessage("Email-edit authorization expired. Please start New Admission again.");
        return;
      }
      const response = await fetch(
        `${API_BASE_URL}/update_mail/${encodeURIComponent(student_id)}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: newEmail.trim().toLowerCase(), edit_token: editToken }),
        }
      );

      const data = await response.json();

      // Explicitly check the 'status' field returned by API
      if (!response.ok || data.status !== "success") {
        if (data.detail === "Email already exists") {
          setErrorMessage("❌ This email is already registered.");
        } else if (data.detail === "Student ID not found") {
          setErrorMessage("❌ Student ID not found.");
        } else {
          setErrorMessage("❌ Error updating email.");
        }

        setTimeout(() => setErrorMessage(""), 5000); // Clear error after 5 sec
      } else {
        const correctedEmail = newEmail.trim().toLowerCase();
        setUserEmail(correctedEmail);
        if (onEmailChanged) onEmailChanged(correctedEmail);
        setIsEditing(false);
        setOtp("");
        setErrorMessage("");
        setSuccessMessage("✅ Email updated successfully.");

        setTimeout(() => setSuccessMessage(""), 5000); // Clear success message after 5 sec
        setNewextraletters(data.extra_code);
      }
    } catch (error) {
      setErrorMessage("⚠️ Network error, please try again.");
      setTimeout(() => setErrorMessage(""), 5000); // Clear error after 5 sec
    } finally {
      setIsSubmitting(false);
       await sleep(700);
      hideLoading();
    }
  };

  const handleResendOTP = async () => {
    setIsResending(true);
    setErrorMessage("");
    setSuccessMessage("");
    showLoading("🔄 Generating new OTP and sending to your email...");

    const randomCode = generateRandomCode(); // Generate a new 4-letter code
    setNewextraletters(randomCode); // Store it in state

    try {
      const response = await fetch(
        `${API_BASE_URL}/send_mailOTP/${encodeURIComponent(student_id)}?email=${encodeURIComponent(userEmail)}&code=${encodeURIComponent(randomCode)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();

      if (response.ok && data.status === "success") {
        setOtp("");
        setSuccessMessage("✅ OTP resent successfully!");
        setTimeout(() => setSuccessMessage(""), 5000); // Clear message after 5 seconds
      } else {
        setErrorMessage("❌ Failed to resend OTP.");
        setTimeout(() => setErrorMessage(""), 5000); // Clear message after 5 seconds
      }
    } catch (error) {
      setErrorMessage("⚠️ Network error, please try again.");
      setTimeout(() => setErrorMessage(""), 5000); // Clear message after 5 seconds
    } finally {
      setIsResending(false);
       await sleep(700);
      hideLoading();
    }
  };

  const handleSubmitOTP = async () => {
    if (otp.length !== 6) {
      setErrorMessage("❌ Please enter a valid 6-digit OTP.");
      setTimeout(() => setErrorMessage(""), 5000); // Clear message after 5 seconds
      return;
    }

    showLoading("⏳ Verifying OTP... Please wait.");

    setIsSubmitting(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const response = await fetch(
        `${API_BASE_URL}/verify_otp/${student_id}?email=${userEmail}&otp=${otp}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        if (!data.admission_session_token) {
          setErrorMessage("Session could not be created. Please verify OTP again.");
          return;
        }

        setSuccessMessage("✅ OTP verified successfully!");
        onClose(data.admission_session_token);
        // setTimeout(() => {
        //   setSuccessMessage("");
        //   onClose(); // Close modal after 5 seconds
        // }, 1000);
      } else {
        setErrorMessage("❌ Invalid OTP, please try again.");
        setTimeout(() => setErrorMessage(""), 5000); // Clear message after 5 seconds
      }
    } catch (error) {
      setErrorMessage("⚠️ Network error, please try again.");
      setTimeout(() => setErrorMessage(""), 5000); // Clear message after 5 seconds
    } finally {
      setIsSubmitting(false);
       await sleep(700);
      hideLoading();
    }
  };

  return (
    <div className="otp-modal-overlay">
      <div className="otp-modal-content">
        {/* Close Button at Top Right */}
        {/* <button className="otp-close-btn" onClick={onClose}>
          close
        </button> */}

        <h2>Email Verification</h2>

        {showEditMail && editToken &&
          (isEditing ? (
            <div className="otp-email-section">
              <input
                type="email"
                className="otp-input"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value.toLowerCase())}
                placeholder="Enter new email"
                maxLength={50}
              />
              <button
                className="otp-submit-btn"
                onClick={handleSubmitEmail}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Updating..." : "Submit Email"}
              </button>
            </div>
          ) : (
            <div className="otp-email-section">
              <div className="otp-email-text email-wrap">📧 {userEmail}</div>
              <button className="otp-edit-btn" onClick={handleEditEmail}>
                Edit Email
              </button>
            </div>
          ))}

        {isEditing && (
          <button className="otp-back-btn" onClick={() => setIsEditing(false)}>
            Back
          </button>
        )}

        {!isEditing && (
          <>
            <div className="otp-to-enter">
              <div className="extra-letter">{Newextraletters}&nbsp;-</div>

              <input
                type="text"
                className="otp-input2"
                placeholder="Enter OTP"
                value={otp}
                onChange={handleOtpChange}
              />
            </div>

            <div className="action-btn-otp">
              <button
                className="otp-submit-btn2"
                onClick={handleSubmitOTP}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Verifying..." : "Submit OTP"}
              </button>
              <button
                className="otp-resend-btn"
                onClick={handleResendOTP}
                disabled={isResending}
              >
                {isResending ? "Sending..." : "Resend OTP"}
              </button>
            </div>
          </>
        )}

        {errorMessage && <p className="otp-error">{errorMessage}</p>}
        {successMessage && <p className="otp-success">{successMessage}</p>}
      </div>
    </div>
  );
};

export default OTPModal;
